<template>
    <b-modal
            id="edit-organization-modal"
            :title="title"
            v-model="showModal"
            centered no-close-on-backdrop
            @ok="handleOk"
            @cancel="handleCancel"
            @close="handleCancel">
        <b-overlay :show="isLoading" rounded="sm">

            <ErrorView :visible="isLoadingError" :errorValue="loadingErrorValue"/>

            <form v-if="isLoadingError == false" ref="form" v-on:submit.prevent="noop">
                <b-form-group
                        label="Name (e.g company name, team name or group)"
                        label-for="name-input"
                        invalid-feedback="Name is required (minimum 3 characters, max 128)"
                        :state="nameState">
                    <b-form-input
                            id="name-input"
                            placeholder="Enter name for organization"
                            v-model="nameValue"
                            required>
                    </b-form-input>
                </b-form-group>
              <b-form-group v-if="primaryImageValid">
                <div>Primary Image (350x100)</div>
                <!--
                <b-form-file
                    accept="image/jpeg, image/png"
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                ></b-form-file>
                -->
                <div class="my-3 p-1" style="width: 260px; margin-left: auto; margin-right: auto; border: 1px solid #666666;">
                  <img style="max-width: 100%; max-height: 100%; display: block; margin-left: auto; margin-right: auto;"
                     v-bind:src="'data:image/png;base64,'+primaryImageValue" alt="( Primary Image 350x100 )" />
                </div>
              </b-form-group>
              <b-form-group
                  v-if="primaryImageValid"
                  label="Use Image in reports"
                  label-for="replace-image-button">
                <b-form-checkbox v-model="replaceReportImageValue" name="replace-image-button" switch>
                  {{replaceReportImageValue ? "On" : "Off"}}
                </b-form-checkbox>
              </b-form-group>
            </form>
          <b-alert show dismissible variant="info">
            <p><font-awesome-icon icon="info" class="mx-2" />You can create multiple organizations and invite other users to enable data sharing.</p>
          </b-alert>
        </b-overlay>
        <template v-slot:modal-footer="{ ok, cancel }">
            <b-button size="sm" variant="primary" @click="ok()">
                Save Changes
            </b-button>
            <b-button size="sm" variant="outline-secondary" @click="cancel()">
                Cancel
            </b-button>
        </template>

        <b-modal id="error-modal" size="sm" title="Action failed" ok-only centered>
            <p class="m-2">There was a problem completing the action, Please try again.</p>
        </b-modal>

    </b-modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import ErrorView from '../ErrorView'

    export default {
        name: "OrganizationModal",
        components: {
            ErrorView
        },
        data() {
            return {

                showModal: false,

                title: "Details",

                nameValue: null,
                primaryImageValid: false,
                primaryImageValue: null,
                replaceReportImageValue: false,

                showValidation: false,

            }
        },
        watch: {
            model(newValue) {
                this.resetModel(newValue);
            },
            showModal(newValue) {
                if(newValue) {
                  this.resetModel(this.model);
                }
            }
        },
        computed: {
            ...mapGetters({
                model: 'organization/current',
                isModelLoading: 'organization/currentLoading',
                isModelLoadingError: 'organization/currentLoadingError',
                modelLoadingErrorValue: 'organization/currentLoadingErrorValue',
            }),

            isLoading: function() {
                return this.isModelLoading;
            },
            isLoadingError: function() {
                return this.isModelLoadingError;
            },
            loadingErrorValue: function() {
                return this.modelLoadingErrorValue;
            },

            nameState: function () {
                if (this.nameValue && this.nameValue.length > 2 && this.nameValue.length < 128) {
                    return true
                }
                return this.showValidation ? false : null
            },
            validatedValue: function() {

                if(this.nameState) {

                    let value = {
                        organizationId: this.model ? this.model.organizationId : undefined,
                        name: this.nameValue,
                        replaceReportImage: this.replaceReportImageValue,
                        primaryImage: this.primaryImageValue,
                    };
                    return value;
                }

                return null;
            },
        },
        methods: {
            ...mapActions({
                save: 'organization/save',
            }),
            resetModel(newValue) {
                this.showValidation = false;
                if (newValue) {
                    this.title = "Edit Organization Details"
                    this.nameValue = newValue.name;
                    this.replaceReportImageValue = newValue.replaceReportImage ? true : false;
                    this.primaryImageValue = newValue.primaryImage;

                    this.primaryImageValid = this.primaryImageValue && this.primaryImageValue.length > 0;


                } else {
                    this.title = "New Organization Details"
                    this.nameValue = null;
                    this.primaryImageValid = false;
                    this.primaryImageValue = null;
                    this.replaceReportImageValue = false;
                }
            },
            handleOk(bvModalEvt) {

                // Prevent modal from closing
                bvModalEvt.preventDefault()

                if (this.isLoading) {
                    return
                }

                if (this.validatedValue != null) {

                    let self = this;
                    this.save(this.validatedValue)
                        .then(function (success) {
                            if(success) {
                                self.resetModel(null);
                                self.closeModal();
                            } else {
                                self.$bvModal.show('error-modal')
                            }
                        })
                } else {
                    this.showValidation = true;
                }
            },
            handleCancel(bvModalEvt) {
                // Prevent modal from closing
                bvModalEvt.preventDefault()

                if (this.isLoading) {
                    return
                }

                this.closeModal()

            },
            closeModal() {
                this.$nextTick(() => {
                    this.$bvModal.hide('edit-organization-modal')
                })
            }
        }
    }
</script>

<style scoped>

</style>